import React from "react";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  fluid?: boolean;
}

const Container: React.FC<ContainerProps> = ({ children, className }) => {
  return (
    <div
      className={`container mx-auto px-5 sm:px-6 lg:px-8 ${className ?? ''}`}
    >
      {children}
    </div>
  );
};

export default Container;
